import React, { useState, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  postSpecialite,
  getSpecialiteById,
} from "./ServiceSpecialite";

export default function UpdateSpecialite() {
   const { t } = useTranslation();
  const { id } = useParams();

  const navigate = useNavigate();

  const [data, setData] = useState({
    id: "",
    natureActivityType: "",
    specialite: "",
    specialiteArab: "",
    specialiteAng: "",
  });

  const [errorMessage, setErrorMessage] = useState({});

  // Chargement des données
  const loadSpecialite = async () => {
    try {
      const result = await getSpecialiteById(id);
      setData(result.data);
    } catch (error) {
      console.error(error);

      toast.error("Impossible de charger l'enregistrement");
    }
  };

  useEffect(() => {
    loadSpecialite();
  }, [id]);

  // Gestion des champs
  const onInputchange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  // Sauvegarde
  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      await postSpecialite(data);

     toast.success(t("specialite.editSuccess"), {
       position: "bottom-right",
    autoClose: 2000,
      });

      setErrorMessage({});

      navigate("/listspecialite");
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        const errorArray = error.response.data.errors;

        const formattedErrors = errorArray.map((err, index) => {
          const message =
            err.indexOf(":") > -1 ? err.split(":")[1] : err;

          return (
            <li className="list-group-item" key={index}>
              {message}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "18rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">
                {t("common.validationErrors")}
              </h5>
            </div>

            <div className="card-body">
              <ul className="list-group list-group-flush">
                {formattedErrors}
              </ul>
            </div>
          </div>,
          {
             position: "bottom-right",
            autoClose: 4000,
          }
        );

        const errorObject = {};

        errorArray.forEach((err) => {
          if (err.indexOf(":") > -1) {
            const [field, message] = err.split(":");

            errorObject[field.trim()] = message.trim();
          }
        });

        setErrorMessage(errorObject);
      } else {
        toast.error(t("validation.updateError"));

        console.error(error);
      }
    }
  };

  return (
    <div
      className="div-width"
      style={{ marginTop: "6rem" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">
          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>

            <Link className="mx-2" to="/">
               {t("menu.home")}
            </Link>
          </li>

          <li className="breadcrumb-item">
            <Link
              className="mx-2"
              to="/Listspecialite"
            >
              Specialité
            </Link>
          </li>

          <li className="breadcrumb-item active">
            {t("button.edit")}
          </li>
        </ol>
      </nav>

      <div className="table-container">
        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-pen-to-square fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">
          <h4 className="ajst-titre mb-4">
            {t("button.edit")}
          </h4>

          <form onSubmit={onSubmit}>
            <div className="row justify-content-center">
              <div className="col-md-6">
                
                          <div className="mb-3">
                  <label className="form-label required-label">
                    id
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="id"
                    value={data.id || ""}
                    readOnly
                    onChange={onInputchange}
                  />

                  {errorMessage.id && (
                    <div className="text-danger mt-1">
                      {errorMessage.id}
                    </div>
                  )}
                </div>

      <div className="mb-3">
                  <label className="form-label required-label">
                    Specialité
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="specialite"
                    value={data.specialite || ""}
                    onChange={onInputchange}
                  />

                  {errorMessage.specialite && (
                    <div className="text-danger mt-1">
                      {errorMessage.specialite}
                    </div>
                  )}
                </div>
 {/* natureActivityType */}
<div className="mb-3">

  <label className="form-label required-label">
    natureActivityType
  </label>

  <select
    className="form-select"
    name="natureActivityType"
    value={data.natureActivityType ?? ""}
    onChange={onInputchange}
  >
    <option value="">-- Sélectionner --</option>
    <option value="C">Crops </option>
    <option value="L">Livestock </option>
  </select>

  {errorMessage.natureActivityType && (
    <div className="text-danger mt-1">
      {errorMessage.natureActivityType}
    </div>
  )}

</div>


                <div className="mb-3">
                  <label className="form-label required-label">
                    Specialité ({t("common.arabic")})
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="specialiteArab"
                    value={data.specialiteArab || ""}
                    onChange={onInputchange}
                    dir="rtl"
                  />

                  {errorMessage.specialiteArab && (
                    <div className="text-danger mt-1">
                      {errorMessage.specialiteArab}
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label required-label">
                    Specialité ({t("common.english")})
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="specialiteAng"
                    value={data.specialiteAng || ""}
                    onChange={onInputchange}
                  />

                  {errorMessage.specialiteAng && (
                    <div className="text-danger mt-1">
                      {errorMessage.specialiteAng}
                    </div>
                  )}
                </div>

              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="submit"
                className="btn btn-outline-primary"
              >
                {t("button.edit")}
              </button>

              <Link
                to="/Listspecialite"
                className="btn btn-outline-success mx-2"
              >
                {t("button.close")}
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}